import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentAttendanceAnalytics from "AttendanceAnalytics/routes/StudentAttendanceAnalytics";

export default store => {
  return {
    path: ":gradeId",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "grade-overview" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [StudentAttendanceAnalytics(store)],
  };
};
